import { render, staticRenderFns } from "./PartImg.vue?vue&type=template&id=c47cdf66"
import script from "./PartImg.vue?vue&type=script&lang=js"
export * from "./PartImg.vue?vue&type=script&lang=js"
import style0 from "./PartImg.vue?vue&type=style&index=0&id=c47cdf66&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports